var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvalidExclamation = function SvgInvalidExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0a6 6 0 0 0-6 6 6.009 6.009 0 0 0 6 6A6 6 0 1 0 6 0Zm.942 9.698c0 .26-.105.495-.276.666a.937.937 0 0 1-.666.277.945.945 0 0 1-.942-.943V9.42c0-.518.424-.943.942-.943s.942.425.942.943v.278Zm0-2.953c0 .26-.105.495-.276.666A.937.937 0 0 1 6 7.688a.945.945 0 0 1-.942-.943V2.302c0-.518.424-.943.942-.943s.942.425.942.943v4.443Z",
    fill: "#DE906F"
  })));
};
export default SvgInvalidExclamation;